import React, { useEffect, useState } from 'react';
import { Button, Header, Loader, Segment } from 'semantic-ui-react';
import { NotificationInfoType } from '../../schemas/notification.schemas';
import NotificationsRepo from '../../utils/repository/notificationsRepo';
import NotificationItem from './components/notificationItem';
import { RESPONSE_STATUS } from '../../constnats/general';
import './notifications.styles.css';
import Alert from '../../utils/alert';

function NotificationsPage() {
    const [notifications, setNotifications] = useState<NotificationInfoType[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        NotificationsRepo.getAll((response) => {
            if (response.status === RESPONSE_STATUS.SUCCESS) {
                setNotifications(response.data);
                setLoading(false);
            } else {
                Alert.warn(response.message);
            }
        });
    }, []);

    const handleMarkedAsRead = (id: number) => {
        setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, isRead: true } : n)));
    };

    const handleMarkedAsUnread = (id: number) => {
        setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, isRead: false } : n)));
    };

    const handleMarkAllAsRead = () => {
        NotificationsRepo.markAllAsRead(() => {
            setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
        });
    };

    const hasUnread = notifications.some((n) => !n.isRead);
    const hasRead = notifications.some((n) => n.isRead);

    const handleDeleteAllRead = () => {
        NotificationsRepo.deleteAllRead(() => {
            setNotifications((prev) => prev.filter((n) => !n.isRead));
        });
    };

    if (loading) {
        return <Loader active inline="centered" />;
    }

    return (
        <div className="notifications-page">
            <div className="notifications-page__header">
                <Header as="h2">Notifications</Header>
                <div>
                    {hasUnread && (
                        <Button basic size="small" onClick={handleMarkAllAsRead}>
                            Mark all as read
                        </Button>
                    )}
                    {hasRead && (
                        <Button basic color="red" size="small" onClick={handleDeleteAllRead}>
                            Delete all read
                        </Button>
                    )}
                </div>
            </div>
            {notifications.length === 0 ? (
                <Segment placeholder textAlign="center">
                    <Header as="h4">No notifications</Header>
                </Segment>
            ) : (
                <Segment className="notifications-page__list">
                    {notifications.map((notification) => (
                        <NotificationItem
                            key={notification.id}
                            notification={notification}
                            onMarkedAsRead={handleMarkedAsRead}
                            onMarkedAsUnread={handleMarkedAsUnread}
                        />
                    ))}
                </Segment>
            )}
        </div>
    );
}

export default NotificationsPage;
